import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import { Authenticated } from '@refinedev/core';
import {
  CatchAllNavigate,
  NavigateToResource,
} from '@refinedev/react-router-v6';
import { ErrorComponent } from '@refinedev/antd';
import { ThemedLayoutV2 } from '../components/layout';
import { ThemedSiderV2 } from '../components/layout/sider';
import { ThemedHeaderV2 } from '../components/layout/header';
import { ThemedTitleV2 } from '../components/layout/title';
import {
  LoginPage,
  ForgotPasswordPage,
  UpdatePasswordPage,
  Verification,
} from '@/pages/auth';
import { UserList, ShowUser } from '@/pages/users';
import { TopicList } from '@/pages/topics';
import { SystemConfigList } from '@/pages/systemConfig';
import { AdminList } from '@/pages/admin';
import {
  ClassesList,
  CreateClass,
  EditClass,
  ShowClass,
} from '@/pages/classes';
import { ContactUsList, ContactUsShow } from '@/pages/contactUs';
import { RequestList, ShowPostReq } from '@/pages/request';
import { PostList, ShowPost } from '@/pages/post';
import { NotificationsList } from '@/pages/notifications';
import { useProfileStore } from '@/core';
export const AppRoutes = () => {
  const { userData } = useProfileStore();
  const userType = userData?.account?.admin?.admin_type;
  return (
    <Routes>
      <Route
        element={
          <Authenticated
            key="authenticated-inner"
            fallback={<CatchAllNavigate to="/login" />}
          >
            <ThemedLayoutV2
              Header={ThemedHeaderV2}
              Title={ThemedTitleV2}
              Sider={(props) => <ThemedSiderV2 {...props} fixed />}
            >
              <Outlet />
            </ThemedLayoutV2>
          </Authenticated>
        }
      >
        <Route path="*" element={<ErrorComponent />} />
        <Route path="/">
          {userType !== 'ACADEMIC_SUPERVISOR' &&
          userType !== 'PROGRAM_HEAD' &&
          userType !== 'SYSTEM_ADMIN' ? (
            <>
              <Route path="/" element={<UserList />} />
              <Route path="/:id" element={<ShowUser />} />
            </>
          ) : (
            <Route path="/" element={<Navigate to="/topics" replace />} />
          )}
        </Route>
        <Route path="/topics" element={<TopicList />} />
        <Route path="/system-config" element={<SystemConfigList />} />
        <Route path="/admins">
          <Route path="/admins" element={<AdminList />} />
        </Route>
        <Route path="/classes">
          <Route path="/classes" element={<ClassesList />} />
          <Route path="/classes/create" element={<CreateClass />} />
          <Route path="/classes/:id" element={<ShowClass />} />
          <Route path="/classes/:id/edit" element={<EditClass />} />
        </Route>
        <Route path="/contact-us">
          <Route path="/contact-us" element={<ContactUsList />} />
          <Route path="/contact-us/:id" element={<ContactUsShow />} />
        </Route>
        <Route path="/listing-request">
          <Route path="/listing-request" element={<RequestList />} />
          <Route
            path="/listing-request/showPostReq/:id/:reqId"
            element={<ShowPostReq />}
          />
        </Route>
        <Route path="/posts">
          <Route path="/posts" element={<PostList />} />
          <Route path="/posts/:id" element={<ShowPost />} />
        </Route>
        <Route path="/notifications" element={<NotificationsList />} />
      </Route>
      <Route
        element={
          <Authenticated key="authenticated-outer" fallback={<Outlet />}>
            <NavigateToResource />
          </Authenticated>
        }
      >
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/reset-password" element={<UpdatePasswordPage />} />
      </Route>
    </Routes>
  );
};
